import type { ChartHover } from './use-chart-hover'

/** Small label that follows the pointer over a chart. */
export function ChartTooltip({ hover }: { hover: ChartHover | null }): React.JSX.Element | null {
  if (!hover) return null
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute z-10 -translate-x-1/2 -translate-y-full rounded-md border bg-popover px-2 py-1 text-xs whitespace-nowrap text-popover-foreground shadow-md"
      style={{ left: hover.x, top: hover.y - 10 }}
    >
      <div className="font-medium">{hover.title}</div>
      <div className="text-muted-foreground tabular-nums">{hover.value}</div>
    </div>
  )
}
